export default "__VITE_ASSET__DOEzxEgE__"